import { Component } from '@angular/core';
import { Http, Response } from '@angular/http';

@Component({
  selector: 'my-about',
  template: require('./contact.component.html'),
  styles:  [require('./contact.component.scss')]
})
export class ContactComponent {

  public name: string;
  public email: string;
  public phone: string;
  public message: string;
  public notifySendOK = false;

  constructor(private http: Http) { }

  sendMessage() {
    console.log('send clicked');

    let msg: WebMessage = new WebMessage();
    msg.To = 'paul@dpibuilders.com';
    msg.From = 'web@dpibuilders.com';
    msg.Config = 'smtp_dpi';
    msg.Body = `From: ${this.name}\r\nEmail: ${this.email}\r\nTelephone: ${this.phone}\r\nMessage: ${this.message}\r\n`;
    msg.Subject = 'Message from dpibuilders.com';

    this.http.put('http://send.foretel.co.uk/api/email/send', msg)
      .map((res: Response) => res.json())
      .subscribe((data: string) => {
        if (data === 'ok') {
          console.log('Message sent ok');
          this.email = this.message = this.phone = this.name = '';
          this.notifySendOK = true;
        } else {
          console.log('Error sending message: ' + data);
        }
    });
  }
}

export class WebMessage {
  public Subject: string;
  public From: string;
  public To: string;
  public Config: string;
  public Body: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/contact.component.ts